/* eslint-disable import/prefer-default-export */

export const NOTE_LIST_UPDATE = 'NOTE_LIST_UPDATE';
export const NOTE_UPDATE = 'NOTE_UPDATE';
export const FILTER_UPDATE = 'FILTER_UPDATE';
export const NOTE_STATUS_UPDATE = 'NOTE_STATUS_UPDATE';
export const SELECTED_NOTE_UPDATE = 'SELECTED_NOTE_UPDATE';
